// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.
/**
 * environment
 */
export const environment = {
  production: true,
  baseUrlMint: '/mint',
  baseUrlNil: '/api', // only if we need a NIL Service, e.g. UserData_GET,
  ecareBaseUrl: '/meinvodafone/services',
  configPath: '/simplicity/after-sales/js/config/',
  simplicityAssets: '/simplicity/assets/',
  svgIcons: '/simplicity/svgdefs.svg',
  featuresConfigPath: '/simplicity/after-sales/js/config/features.json',
  cmsWordingPath: '/wording/after-sales/',
  cmsConfigPath: '/config/after-sales/',
  cmsErrorMessagesPath: '/api-static/errormessages/',
  vluxGate: 'vluxgate/vlux',
  baseUrlDxl: '/api/dxl',
  baseUrlDxlProd: 'https://api.vodafone.de',
  baseUrlDxlTestFullPath: 'https://dxl.test.api.vodafone.de',
  baseUrlDxlPreProdFullPath: 'https://dxl.preprod.api.vodafone.de',
  baseUrlDxlPreProd: 'dxl.preprod',
  baseUrlDxlSIT: 'https://integration.preprod.api.vodafone.de/meinvodafone/v1',
  baseUrlDxlProdV2: 'https://dxl.preprod.api.vodafone.de',
};
